import { render, staticRenderFns } from "./WrongEbook.vue?vue&type=template&id=18cba99c&scoped=true"
import script from "./WrongEbook.vue?vue&type=script&lang=js"
export * from "./WrongEbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cba99c",
  null
  
)

export default component.exports